import React, { useState } from 'react';
import { FiArrowRight } from 'react-icons/fi';
import './CaWhyChooseUs.css';

const CaWhyChooseUs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabsData = [
    {
      label: 'Established in 2013',
      title: 'Established in 2013, Over a Decade of Proven Results',
      content: 'We have been teaching the Quran online since 2013. That is not a marketing claim; it is a verifiable track record of 13+ years of continuous operation, curriculum refinement, and 5,000+ students successfully guided through their Quranic journey with certificates on their Quran completion. Experience matters in education.'
    },
    {
      label: '3-Day Free Trial',
      title: '3-Day Free Trial, No Credit Card Required',
      content: 'We believe our teaching speaks for itself. That is why we offer a completely free 3-day trial. Three full live sessions with a certified tutor before you pay anything. No credit card. No contract. No pressure. Try it, experience it, and only then decide.'
    },
    {
      label: 'Certified, Native Arabic-Speaking Tutors',
      title: 'Certified, Native Arabic-Speaking Tutors Only',
      content: 'Every tutor at Al Quran Lesson is a native Arabic speaker with a formal certification in Quranic education. They are not hobbyist teachers or freelancers, they are qualified Islamic scholars and educators who have been trained, vetted, and tested before they teach a single student. Your child learns from the best.'
    },
    {
      label: '100% One-on-One Live Sessions',
      title: '100% One-on-One Live Sessions | No Group Classes',
      content: 'We do not offer group classes. Every session is private, one-on-one, and conducted live between your child (or you) and a single dedicated tutor. This means undivided attention, real-time correction, and a learning pace tailored to the individual, not the class average.'
    },
    {
      label: 'Male and Female Tutors',
      title: 'Male and Female Tutors Available',
      content: 'We respect the diversity of preferences within the Muslim community. Families can choose a male or female tutor based on their child’s needs and comfort for both male and female students. This choice is available at no extra cost and can be changed at any time.'
    },
    {
      label: '24/7 Availability',
      title: '24/7 Availability, Built for Canada Time Zones',
      content: 'Muslim families across Canada span multiple time zones and busy schedules. Our academy operates 24 hours a day, 7 days a week, with tutors available across Canadian time zones. Morning, evening, weekend. You choose the time that works, and we will make it happen.'
    },
    {
      label: 'Flexible Scheduling For Canadian Families',
      title: 'Flexible Scheduling That Fits Canadian Life',
      content: 'School runs, work meetings, weekend activities. Canadian family life is demanding. We schedule sessions around your routine, not ours. You can reschedule with notice, adjust session frequency, or pause your subscription during breaks. Your Quran education should not add stress; it should relieve it.'
    },
    {
      label: 'Completion Certificates',
      title: 'Completion Certificates for Every Course',
      content: 'Upon completing any course at Al Quran Lesson, students receive an official completion certificate. For children, this is a meaningful milestone. For adults, it is formal recognition of their dedication and achievement.'
    }
  ];

  return (
    <section
      className="Ca-why-choose-us"
      id="why-choose-us"
    >
      <div className="Ca-why-choose-us__container">
        {/* Headings */}
        <h2 className="Ca-why-choose-us__title">
          Why Thousands of Muslim Families in Canada Choose Al Quran Lesson
        </h2>
        <p className="Ca-why-choose-us__subtitle">
          There are many online Quran academies. Here is what makes us the choice that parents trust and students stay with:
        </p>

        {/* Tabs Control Row */}
        <div className="Ca-why-choose-us__tabs-container">
          <div className="Ca-why-choose-us__tabs-row">
            {tabsData.slice(0, 3).map((tab, index) => (
              <button
                key={index}
                className={`Ca-why-choose-us__tab-btn ${activeTab === index ? 'Ca-why-choose-us__tab-btn--active' : ''}`}
                onClick={() => setActiveTab(index)}
              >
                <span>{tab.label}</span>
                {activeTab === index && (
                  <FiArrowRight className="Ca-why-choose-us__tab-arrow" />
                )}
              </button>
            ))}
          </div>

          <div className="Ca-why-choose-us__tabs-row">
            {tabsData.slice(3, 6).map((tab, idx) => {
              const index = idx + 3;
              return (
                <button
                  key={index}
                  className={`Ca-why-choose-us__tab-btn ${activeTab === index ? 'Ca-why-choose-us__tab-btn--active' : ''}`}
                  onClick={() => setActiveTab(index)}
                >
                  <span>{tab.label}</span>
                  {activeTab === index && (
                    <FiArrowRight className="Ca-why-choose-us__tab-arrow" />
                  )}
                </button>
              );
            })}
          </div>

          <div className="Ca-why-choose-us__tabs-row">
            {tabsData.slice(6, 8).map((tab, idx) => {
              const index = idx + 6;
              return (
                <button
                  key={index}
                  className={`Ca-why-choose-us__tab-btn ${activeTab === index ? 'Ca-why-choose-us__tab-btn--active' : ''}`}
                  onClick={() => setActiveTab(index)}
                >
                  <span>{tab.label}</span>
                  {activeTab === index && (
                    <FiArrowRight className="Ca-why-choose-us__tab-arrow" />
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Content Box */}
        <div className="Ca-why-choose-us__content-box">
          <h3 className="Ca-why-choose-us__content-title">
            {tabsData[activeTab].title}
          </h3>
          <p className="Ca-why-choose-us__content-text">
            {tabsData[activeTab].content}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CaWhyChooseUs;
